import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";

@inheritSerialization(BaseUUIDEntity)
export default class UserMerchant extends BaseUUIDEntity {

	@serialize
	@deserialize
	public merchant_code: string = "";

	@serialize
	@deserialize
	public merchant_name: string = "";

	@serialize
	@deserialize
	public phone: string = "";

	@serialize
	@deserialize
	public user_profile: string = "";

	@serialize
	@deserialize
	public status: boolean = false;

}
